import { Component, Input } from '@angular/core';
import { ChunkSettings, FileInfo, UploadEvent } from '@progress/kendo-angular-upload';

declare var CURRENT_USER_ID: number

@Component({
    selector: 'app-filevault-data',
    templateUrl: './filevault-data.component.html',
    styleUrl: './filevault-data.component.css',
    standalone: false
})
export class FilevaultDataComponent {
  @Input() draftId?: number;
  @Input() readonly: boolean = false;
  uploadSaveUrl = `/Files()/CheckIn`; // should represent an actual API endpoint
  uploadRemoveUrl = "removeUrl"; // should represent an actual API endpoint
  public files!: Array<FileInfo>;
  public chunkSettings: ChunkSettings = {
    size: 102400,
  };
  ngOnInit(): void {
    if(this.draftId !== undefined && this.draftId !== null){
      // this.service.getOrderFiles(this.draftId.toString()).subscribe(xFiles => {
      //   console.log(xFiles);
      //   this.files = xFiles['data'].map(x=> ({ name: x.File.FileName }));
      // })
    }
  }
  uploadEventHandler(e: UploadEvent): void {
    e.data = {
      fileDescription: "EJDF Upload",
      revision: "0",
      userId: CURRENT_USER_ID,
      note: ' ',
      targetId: this.draftId,
      applicationType: '2',
      isOculus: false
    };
  }
}
